import { getConceptCodes } from "@intocare/datatypes/lib/code-system";
import { composeValueSet } from "@intocare/datatypes/lib/value-set";

import { OBSERVATION_CONTEXT_ABSENT_REASON } from "../../code-system/observation-context-absent-reason";

export const OBSERVATION_CONTEXT_ABSENT_REASON_DISPLAY = composeValueSet({
	name: "OBSERVATION_CONTEXT_ABSENT_REASON_DISPLAY",
	description: "Current selection of absent reasons for displaying observations.",
	system: OBSERVATION_CONTEXT_ABSENT_REASON,
	include: getConceptCodes(OBSERVATION_CONTEXT_ABSENT_REASON),
});
